import type { PuzzleMode } from '../../engine/types';
import { BloomBoard } from './Board';
import {
  BLOOM_DIFFICULTIES,
  deserialize,
  generate,
  handleKey,
  hint,
  moveFeedback,
  reduce,
  score,
  status,
  summarize,
  validateMove,
  type BloomConfig,
  type BloomMove,
  type BloomState,
} from './logic';

export const bloomMode: PuzzleMode<BloomState, BloomMove, BloomConfig> = {
  id: 'bloom',
  name: 'Bloom',
  tagline: 'Fill in the vowels',
  description:
    'The consonants are given; the vowels are missing. Fill them in to make the word bloom — any word that fits counts.',
  accent: 'berry',
  glyph: 'sparkle',
  howToPlay: [
    { title: 'Read the skeleton', body: 'The consonants are shown in place; the gaps are vowels (A, E, I, O, U).' },
    { title: 'Fill the gaps', body: 'Tap or type vowels to fill the empty slots from left to right.' },
    { title: 'Make a word', body: 'Any valid word that fits the consonants counts — there may be more than one.' },
  ],
  difficulties: BLOOM_DIFFICULTIES,
  defaultDifficultyId: 'standard',
  generate,
  reduce,
  status,
  validateMove,
  moveFeedback,
  handleKey,
  hint,
  score,
  summarize,
  serialize: (state) => state,
  deserialize,
  Board: BloomBoard,
};
